import { render, staticRenderFns } from "./BDXStatusModalFormFCPToggle.vue?vue&type=template&id=c4abdaae"
import script from "./BDXStatusModalFormFCPToggle.vue?vue&type=script&lang=js"
export * from "./BDXStatusModalFormFCPToggle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports